export enum IncentivationSourceType {
    ManualActionIncentivationSource = "ManualActionIncentivationSource",
}

export interface BaseIncentivationSourceModel {
    type: IncentivationSourceType
};

export type EditorIncentivationSource = Omit<BaseIncentivationSourceModel, "type">;

export interface ManualActionIncentivationSourceModel extends BaseIncentivationSourceModel {
    canBulkUploadIncentivationData: boolean;
    canBeCompletedByEmployeeUser: boolean;
};

export function isBaseIncentivationSourceModel(value: unknown): value is BaseIncentivationSourceModel {
    return (
        typeof value === "object" &&
        value !== null &&
        "type" in value &&
        Object.values(IncentivationSourceType).includes((value as BaseIncentivationSourceModel).type)
    );
}

export function isManualActionIncentivationSourceModel(value: unknown): value is ManualActionIncentivationSourceModel {
    return (
        isBaseIncentivationSourceModel(value) &&
        value.type === IncentivationSourceType.ManualActionIncentivationSource &&
        "canBulkUploadIncentivationData" in value &&
        typeof (value as ManualActionIncentivationSourceModel).canBulkUploadIncentivationData === "boolean" &&
        "canBeCompletedByEmployeeUser" in value &&
        typeof (value as ManualActionIncentivationSourceModel).canBeCompletedByEmployeeUser === "boolean"
    );
}
